import Drift from "@components/marketing-scripts/driftt"
import MunchkinScript from "@components/marketing-scripts/munchkin"
import OneTrust from "@components/marketing-scripts/onetrust"
import SpeedCurve from "@components/marketing-scripts/speedcurve"
import StructuredData from "@components/marketing-scripts/structured-data"
import Intellimize from "./marketing-scripts/intellimize"
import Pendo from "./marketing-scripts/pendo"
import { useEffect } from "react"
// Not really ALL the scripts anymore. The OneTrust (cookie banner) script
// has been moved to gatsby-browser.
const AllTheScripts = () => {
  useEffect(() => {
    const searchParameters = document.location.search
    const urlParams = new URLSearchParams(searchParameters)
    const gclidCookie = urlParams.get("gclid")
    if (gclidCookie) {
      document.cookie = `_gclid=${gclidCookie}; path=/;`
    }
  })
  return (
    <>
      <Pendo />
      <Intellimize />
      <SpeedCurve />
      <MunchkinScript />
      <OneTrust />
      <Drift />
      <StructuredData />
      <script>{`performance.mark("scripts done blocking");`}</script>
    </>
  )
}

export default AllTheScripts
